import React, {useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../../../hooks/usePermissions";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {ContainerTable} from "../../../../components/Containers/ContainerTable";
import {UseLoader} from "../../../../hooks/useLoader";
import {confirmDialog} from "primereact/confirmdialog";
import {eliminarLiquidacion, pagarFacturas} from "../../../../api/liquidacion.service";
import {Toast} from "primereact/toast";
import {ContainerGroupForm} from "../../../../components/Containers/ContainerGroupForm";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import {locales} from "../../../../shared/types/constantes";


export const TablePagoLiquidacion = ({pendientes, reload}) => {
    const [permisos] = UsePermissions()
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [selected, setSelected] = useState([]);
    const [fecha, setFecha] = useState(new Date());

    useEffect(() => {
        if (selected.length > 0) {
            setSelected([])
        }

    }, [pendientes]);


    const aplicarPago = () => {

        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {

                    handleLoad(true);
                    const payload = {
                        data: selected,
                        fecha
                    }
                    const response = await pagarFacturas(payload);

                    handleLoad(false)

                    if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    reload()
                }
            });

        } catch (e) {
            handleLoad(false);
            console.log(e);
        }

    }

    addLocale('es', locales);

    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={aplicarPago}
                >
                    <i className="fa fa-money-bill"/>
                </button>
            </div>


        </div>
    );

    const footer = (
        <div className="flex align-items-center ">
            <ContainerGroupForm width="lg:w-2/12">
                <label
                    style={{paddingTop: "15px"}}
                    className="label-form"
                    htmlFor="fechacrea"
                >
                    Fecha de pago *
                </label>
            </ContainerGroupForm>
            <ContainerGroupForm width="lg:w-4/12">

                <Calendar id="fechacrea"
                          value={fecha}
                          locale="es"
                          monthNavigator={true}
                          yearNavigator={true}
                          yearRange='2010:2030'
                          dateFormat="yy-mm-dd"
                          style={{width: "100%"}}
                          onChange={(e) => setFecha(e.value)} showIcon/>

            </ContainerGroupForm>
        </div>


    );
    return (
        <ContainerTable>
            <Toast ref={toast}/>
            <DataTable
                showGridlines
                value={pendientes}
                header={header}
                footer={footer}

                size="small"
                scrollable scrollHeight="400px"
                selection={selected} onSelectionChange={e => setSelected(e.value)} responsiveLayout="scroll">
                <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
                <Column sortable  filter field="nombre" headerStyle={{width: '1em'}} header="Nombre"></Column>
                <Column sortable  filter field="num_factura" headerStyle={{width: '1em'}} header="Factura"></Column>
            </DataTable>
        </ContainerTable>
    );
};


